
import {get,writable} from 'svelte/store'



let getLocation = (store)=> {    
    if ('geolocation' in navigator) {
        let location = {}
        navigator.geolocation.getCurrentPosition((position) => {
            //console.log(position)
            location.latitude = position.coords.latitude
            location.longitude = position.coords.longitude
            store.set(Promise.resolve(location))
        });
    } else {    
        store.set(Promise.reject("no geolocation found"))
    }
}    
export function getCurrentLocation(){
    const mylocation = writable(new Promise(()=>{}))
    getLocation(mylocation)
    return mylocation;

}


const baseUrl =  location.origin + location.pathname  ;

export let authenticated = writable(false)

const token = writable(localStorage.getItem("token") || null);
token.subscribe(function(val){
    if(val == null || val == ''){
        authenticated.set(false)
        window.localStorage.removeItem("token")
    }else{
        window.localStorage.setItem("token", val)
        authenticated.set(true)
     }
    });


export async function logout(){  
    try{
        let resp = await fetch( baseUrl + "auth/logout",{
            method:"POST",
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + get(token) }
        })
        if(resp.status == 200) {
            token.set(null)   
            window.history.replaceState(null,'index',baseUrl)
            delete  document.cookie
        }

    }catch(err){
        // console.log(err)
    }finally{
            token.set(null)   
            window.history.replaceState(null,'index',baseUrl)
            delete  document.cookie
    }  

    return null;
}

export async function register(data){
        
            const url = baseUrl + 'register'
            return fetch(url,{
                method:'POST',
                body:JSON.stringify(data)
            })           
        
}

export  function auth(username,password){
    let url = baseUrl  + "auth/token"
    let credentials = new FormData()
    credentials.append('username' ,username)
    credentials.append('password',password)
    
    return fetch(url,{
        method:'POST',
        cache:'no-cache',
        body:credentials

    }).then(resp => {       
        return resp.json().then(data=> {   
           
            if(resp.ok){
                token.set(data.access_token)                 
                return Promise.resolve(authenticated)
            }else {
                return Promise.reject({status:resp.status,detail:data.detail})
            }
        })        
    })
}

const urls = {
    governorates: baseUrl + 'governorates',
    stations:     baseUrl + 'stations',    
    nearme:       baseUrl + 'nearme',
    profile:      baseUrl + 'users/me',
    changepass:   baseUrl + 'users/me/upass',
    changeemail:  baseUrl + 'users/me/uemail',
    users :       baseUrl + 'users',
    roles:        baseUrl + 'roles',
    permissions:  baseUrl + 'permissions',
    tickets:      baseUrl + 'tickets'    
}


const cache = new Map()

const load = async (url,store,preprocess) => {  
    if(typeof(url) == undefined) return;
    try{
        const response = await fetch(url, {
            method: 'GET',
            cache: 'no-cache',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + get(token) },
            
        })        
        if (!response.ok) {
            const error = await response.json()
            if(response.status == 401 || response.status == 409){
                logout()
            }else {
                store.set(Promise.reject(error))
            }
    
        } else {
            const data = await response.json()
            if(preprocess)
                data = preprocess(data)
            store.set(Promise.resolve(data))
        }
        
    }catch(err){        
        store.set(Promise.reject(err))           
    }
}


export function getResource(resource,qs = null){       
    let url = urls[resource] +  (qs? '?' + new URLSearchParams(qs):'')        
    const store = writable(new Promise(() => { }))
    if (cache.has(url)) {
        store.set(Promise.resolve(cache.get(url)))
    }    
    load(url, store)
    return store;
}


export function getResourceById(resource, resource_id) {
    let url = urls[resource] + '/' + resource_id
    const store = writable(new Promise(() => { }))
    if (cache.has(url)) {
        store.set(Promise.resolve(cache.get(url)))
    }
    load(url, store)
    return store;
}

const post = async (url,method,store,data) => {   
    try{
        const response = await fetch(url,{
            method,
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + get(token)
            },
            body:JSON.stringify(data)
        })
        const response_data = await response.json();
        
        if(response.ok){
            store.set(Promise.resolve(response_data))
        }else{
            store.set(Promise.reject(response_data))            
        }
    }catch(err){        
        //console.log('some error here ... !!!!')
        store.set(Promise.reject(err))
    }   
}

export function postResource(resource,data){
    let url = urls[resource]
    const store = writable(new Promise(() => {}))
    post(url,'POST',store,data)
    return store
}


export function updateResource(resource,resource_id,data){
    let url = urls[resource] + '/' + resource_id 
    const store = writable(new Promise(()=> {}))
    post(url,'PUT',store,data)
    return store
}


export function resetPassword(user_id){    
    let url = baseUrl + 'users/' + user_id + '/reset'    
    const store = writable(new Promise(() => { }))
    post(url,'PUT',store,null)
    return store
}


export function uploadImage(resource,resource_id,file){
    if(!resource_id) throw Error('station_id can not be null')
    if(file == null || typeof(file) == undefined ) throw Error('file can not be empty')
    let url = baseUrl + resource +'/' + resource_id + '/upload'
    const fd = new FormData()
    fd.append('image',file)
    const upload = async (url)=>{
        const resp = await  fetch(url,{
            method:'POST',
            headers:{  'Authorization': 'Bearer ' + get(token) },
            body:fd
        })
        return resp.json()
    }    
    return upload(url)    
}

export function uploadImages(resource,resource_id,files){
    if(!resource_id) throw Error('station_id can not be null')
    if(files == null || typeof(files) == undefined ) throw Error('file can not be empty')
    let url = baseUrl + resource +'/' + resource_id + '/uploads'
    const fd = new FormData()
    
    
    for(const file of files){    
        fd.append( 'files',file)    
    }
    
    const upload = async (url)=>{
        const resp = await  fetch(url,{
            method:'POST',
            headers:{  'Authorization': 'Bearer ' + get(token) },
            body:fd
        })
        return resp.json()
    }    
    return upload(url)    
}


export function deleteImage(img){
    let url = baseUrl + 'stations/' + img.station_id + '/images/' + img.id
    try{
        const delete_ = async (url) => {
            const resp = await fetch(url,{
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + get(token)
                }
            })
            if(!resp.ok){
                return Promise.reject("something went wrong")
            }
            return resp.json()
        }
        return delete_(url)
    }catch (error) { return Promise.reject(error) }
}



export function fakePostResource(resource , data){
    const store = writable(new Promise(()=>{}))

    setTimeout(()=>{
        // store.set(Promise.resolve(data))
        store.set(Promise.reject('error'))
    },1000)
    return store

}